module.exports = __webpack_public_path__ + "img/apps.014db52b.png";